import { Cycle } from '@teetsh/app/src/containers/scholarSystem';

export const BILAN_EVENT = 'bilan';
export const RAPPEL_EVENT = 'rappel';
export const BREAK_EVENT = 'break';
export const RITUEL_EVENT = 'rituel';
export const CLASSIC_EVENT = 'classic';
export const LOADING_EVENT = 'loading';
export const ADD_EVENT = 'add-event';

export const GRACE_PERIODE_IN_DAYS = 14;

export const defaultFrTags: Record<Cycle, string[]> = {
  'Cycle 1': [
    'Développement et structuration du langage oral et écrit',
    "Agir, s'exprimer, comprendre à travers l'activité physique",
    "Agir, s'exprimer, comprendre à travers les activités artistiques",
    'Acquisition des premiers outils mathématiques',
    'Explorer le monde',
    'Apprendre ensemble et vivre ensemble',
    'Récréation',
  ],
  'Cycle 2': [
    'Français',
    'Langues vivantes (étrangères ou régionales)',
    'Enseignements artistiques',
    'Éducation physique et sportive',
    'Questionner le monde',
    'Mathématiques',
    'Enseignement moral et civique',
    'Récréation',
  ],
  'Cycle 3': [
    'Français',
    'Langues vivantes (étrangères ou régionales)',
    'Arts plastiques',
    'Éducation physique et sportive',
    'Mathématiques',
    'Enseignement moral et civique',
    'Éducation musicale',
    'Histoire des arts',
    'Histoire et géographie',
    'Sciences et technologie',
    'Récréation',
  ],
  'Cycle 4': [
    'Français',
    'Langues vivantes (étrangères ou régionales)',
    'Arts plastiques',
    'Éducation musicale',
    'Histoire des arts',
    'Éducation physique et sportive',
    'Histoire et géographie',
    'Physique-Chimie',
    'Sciences de la vie et de la Terre',
    'Technologie',
    'Mathématiques',
    "Éducation aux médias et à l'information",
    'Enseignement moral et civique',
    'Récréation',
  ],
};
